import React from 'react';
import './TitleSection.css';

const TitleSection = () => {
  return (
    <section className="title-section">
      <h1>Get in Touch</h1>
      <p>
        Whether you’re interested in working together, have a question, or just want to say hello —
        feel free to drop a message.
      </p>
    </section>
  );
};

export default TitleSection;
